





























































































































































































import { Vue, Component, Prop, PropSync, Watch } from "vue-property-decorator";
import store from "@/store";
//  types
import { ICustomExpressionItem, CustomExpressionData } from "@/types/CustomExpressionData";
import { LogVariable } from "@/types/logVariable";
import { FeatureAttribute } from "@/types/cds/featureAttribute";
//  components
import CustomExpressionSelect from "@/components/Notifications/CustomExpressionSelect.vue";
import MathematicalExpressionSelect from "@/components/Notifications/MathematicalExpressionSelect.vue";
//  modules
import { getModule } from "vuex-module-decorators";
import LogVariablesModule from "@/store/clients/LogVariables.module";
import VesselsModule from "@/store/clients/Vessels.module";
import CdsModule from "@/store/clients/Cds.module";
import { indexBy } from "underscore";

const LogVariables = getModule(LogVariablesModule, store);
const Vessels = getModule(VesselsModule, store);
const Cds = getModule(CdsModule, store);

@Component({
  components: {
    CustomExpressionSelect,
    MathematicalExpressionSelect,
  },
})
export default class CustomExpressionsDialog extends Vue {
  @PropSync("value", { required: true }) isModalActive!: boolean;
  @PropSync("maxWidth", { default: 1000 }) dialogWidth!: number;
  @Prop({ required: true, default: () => [] }) customExpressionItemsList!: ICustomExpressionItem[];
  @Prop() disabledItems!: number[];
  @Prop({ default: false }) grouped!: boolean;
  @Prop({ default: false }) operatorSelectAvailable!: boolean;

  // @Watchers
  @Watch("isModalActive")
  onOpenModal(): void {
    if (this.isModalActive) {
      // Deep clone all items for local editing
      this.localExpressionItemsList = JSON.parse(JSON.stringify(this.customExpressionItemsList));
      // Ensure each vessel has at least one empty expression if none exist
      this.localExpressionItemsList.forEach((item, idx) => {
        if (!item.expressions || item.expressions.length === 0) {
          item.expressions = JSON.parse(JSON.stringify(this.EmptyExpressionsList[idx].expressions));
        }
      });
      // Set current type based on first item
      if (this.localExpressionItemsList.length) {
        this.currentExpressionType = this.localExpressionItemsList[0].expressionType === "Logical" ? this.expressionTypes[0] : this.expressionTypes[1];
      }
    }
  }

  @Watch("customExpressionItemsList", { deep: true })
  onCustomExpressionItemsListChanged(): void {
    if (this.grouped) {
      this.localExpressionItemsList = JSON.parse(JSON.stringify(this.customExpressionItemsList));
      this.localExpressionItemsList.forEach((item, idx) => {
        item.expressions = JSON.parse(JSON.stringify(this.EmptyExpressionsList[idx].expressions));
      });
    } else {
      if (this.customExpressionItemsList[0].expressions.length) {
        this.localExpressionItemsList = JSON.parse(JSON.stringify(this.customExpressionItemsList));
      }
    }
  }

  @Watch("currentExpressionType", { deep: true })
  onCurrentExpressionTypeChanged(): void {
    if (this.grouped) {
      this.localExpressionItemsList = JSON.parse(JSON.stringify(this.customExpressionItemsList));
      this.localExpressionItemsList.forEach((item, idx) => {
        item.expressions = JSON.parse(JSON.stringify(this.EmptyExpressionsList[idx].expressions));
      });
    } else {
      if (this.customExpressionItemsList[0].expressions.length) {
        this.localExpressionItemsList = JSON.parse(JSON.stringify(this.customExpressionItemsList));
      }
    }
  }

  // @Data
  expressionsList: CustomExpressionData[] = [];
  localExpressionItemsList: ICustomExpressionItem[] = [];
  expressionTypes = [
    { type: "CustomExpressionSelect", text: "Logical" },
    { type: "MathematicalExpressionSelect", text: "Mathematical" },
  ];
  currentExpressionType = { type: "CustomExpressionSelect", text: "Logical" };

  // @Getters
  get EmptyExpressionsList(): Partial<ICustomExpressionItem>[] {
    return this.customExpressionItemsList.map(item => {
      // For Mathematical, ensure content/mathContent are empty strings
      if (item.expressionType === "Mathematical") {
        return {
          vesselName: item.vesselName,
          vesselId: item.vesselId,
          expressions: [
            {
              vesselName: item.vesselName,
              vesselId: item.vesselId,
              logVariable: null,
              amount: 0,
              symbol: "",
              operator: null,
              content: "",
              mathContent: "",
              mathContentArray: [],
              expressionType: "Mathematical",
            },
          ],
          expressionType: "Mathematical",
        };
      }
      // For Logical, ensure logVariable/symbol are null/empty
      return {
        vesselName: item.vesselName,
        vesselId: item.vesselId,
        expressions: [
          {
            vesselName: item.vesselName,
            vesselId: item.vesselId,
            logVariable: null,
            amount: 0,
            symbol: "",
            operator: null,
            content: null,
            mathContent: "",
            expressionType: "Logical",
          },
        ],
        expressionType: "Logical",
      };
    });
  }

  get isModalGrouped(): boolean {
    return this.grouped;
  }

  isExpressionTypeSelectDisabled(): boolean {
    if (!this.grouped) {
      if (this.customExpressionItemsList[0].expressionType === "Mathematical") {
        return Boolean(
          this.customExpressionItemsList[0].expressions && this.customExpressionItemsList[0]?.expressions[0]?.mathContent && this.customExpressionItemsList[0]?.expressions[0]?.mathContent.length > 0
        );
      } else if (this.isOperatorSelectAvailable(0, 0)) {
        return true;
      } else {
        return Boolean(
          this.customExpressionItemsList[0].expressions &&
            this.customExpressionItemsList[0]?.expressions[0]?.logVariable != null &&
            this.customExpressionItemsList[0]?.expressions[0]?.content &&
            this.customExpressionItemsList[0]?.expressions[0]?.content.length > 0
        );
      }
    } else return false;
  }

  expressionSelectType(expressionType: string | undefined): string {
    if (this.grouped) return this.currentExpressionType.type;
    return expressionType === "Logical" ? "CustomExpressionSelect" : "MathematicalExpressionSelect";
  }

  isLogicExpressionApplied(vesselId: number | undefined): boolean {
    const expressionItem = this.customExpressionItemsList.find(item => item.vesselId === vesselId);
    return Boolean(expressionItem && expressionItem.expressions.length > 0 && expressionItem.expressions[0].expressionType === "Logical" && expressionItem.expressions[0].content != null);
  }

  get expressionType(): string {
    return this.currentExpressionType.text;
  }

  get isLogicalType(): boolean {
    return this.currentExpressionType.type === "CustomExpressionSelect";
  }

  get isSaveDisabled(): boolean {
    // For Logical expressions: logVariable and symbol must be set for every expression
    if (this.currentExpressionType.type === "CustomExpressionSelect") {
      return this.localExpressionItemsList.some(item => item.expressions.some(expr => !expr.logVariable || !expr.symbol));
    }
    // For Mathematical expressions: mathContent must be set for every expression
    else if (this.currentExpressionType.type === "MathematicalExpressionSelect") {
      return this.localExpressionItemsList.some(item => item.expressions.some(expr => !expr.mathContent || expr.mathContent.length === 0));
    }
    return true;
  }

  // @Methods
  open(): void {
    this.isModalActive = true;
    this.$emit("open");
  }

  close(): void {
    this.isModalActive = false;
    this.$emit("close");
    this.expressionsList = JSON.parse(JSON.stringify(this.EmptyExpressionsList)) as CustomExpressionData[];
  }

  save(): void {
    this.isModalActive = false;
    // Filter invalid expressions for each vessel
    const filteredItems = this.localExpressionItemsList.map(item => ({
      ...item,
      expressions: item.expressions.filter(exp => (this.expressionType === "Logical" ? exp.logVariable && exp.symbol : exp.content !== null)),
    }));
    this.$emit("save", filteredItems);
    this.localExpressionItemsList = [];
  }

  addNewExpression(item: ICustomExpressionItem): void {
    const targetIndex = this.localExpressionItemsList.findIndex(v => v.vesselId === item.vesselId);
    if (targetIndex === -1) return;

    const newExpression = {
      vesselName: this.localExpressionItemsList[targetIndex].vesselName,
      vesselId: this.localExpressionItemsList[targetIndex].vesselId,
      logVariable: null,
      amount: 0,
      symbol: "",
      operator: null,
      content: this.currentExpressionType.type === "MathematicalExpressionSelect" ? "" : null,
      mathContent: this.currentExpressionType.type === "MathematicalExpressionSelect" ? "" : "",
      expressionType: this.currentExpressionType.text,
    };

    // Use Vue.set to add the new expression reactively
    this.$set(this.localExpressionItemsList[targetIndex].expressions, this.localExpressionItemsList[targetIndex].expressions.length, newExpression);
  }

  onMathExpressionChanged(): void {
    this.expressionsList = JSON.parse(JSON.stringify(this.expressionsList)) as CustomExpressionData[];
  }

  onExpressionTypeChanged(): void {
    this.$emit("onTypeChanged", this.expressionType);
  }

  async onCopyCondition(): Promise<void> {
    // Get the source expressions from the first vessel
    const sourceItem = this.localExpressionItemsList[0];
    if (!sourceItem || !sourceItem.expressions.length) return;

    // For each other vessel, copy the expressions
    for (let i = 1; i < this.localExpressionItemsList.length; i++) {
      const targetItem = this.localExpressionItemsList[i];
      if (!targetItem) continue;

      // Deep clone the source expressions
      const newExpressions = await Promise.all(
        sourceItem.expressions.map(async srcExpr => {
          // Find the correct log variable/feature for the target vessel by name
          let logVariable = null;
          if (srcExpr.logVariable?.name) {
            logVariable = await this.logVariableByNameAndVesselId(targetItem.vesselId, srcExpr.logVariable.name);
          }

          return {
            ...srcExpr,
            vesselId: targetItem.vesselId,
            vesselName: targetItem.vesselName,
            logVariable,
          };
        })
      );

      // Replace the target vessel's expressions with the copied ones
      this.$set(this.localExpressionItemsList[i], "expressions", newExpressions);
    }
  }

  isExpressionSelectDisabled(vesselId: number): boolean {
    if (!this.disabledItems || !this.disabledItems.length) return false;
    return this.disabledItems.includes(vesselId);
  }

  isOperatorSelectAvailable(expressionItemIndex: number, expressionIndex: number): boolean {
    const item = this.localExpressionItemsList[expressionItemIndex];
    if (!item || !item.expressions || expressionIndex === 0) return true;
    const prev = item.expressions[expressionIndex - 1];
    return Boolean(prev && prev.logVariable && prev.symbol && prev.amount !== null && prev.amount !== undefined);
  }

  isCopyConditionAvailable(expressionItemIndex: number, expressionIndex: number, expression: CustomExpressionData): boolean {
    return this.grouped && expression.logVariable && expression.symbol && expression.amount != null && expressionItemIndex === 0 && expressionIndex === 0 ? true : false;
  }

  async logVariableByNameAndVesselId(vesselId: number, name: string): Promise<LogVariable | FeatureAttribute | null> {
    const vessel = await Vessels.get(vesselId);
    if (vessel?.onboardSystem === "Nautilus") {
      return Cds.featureByVesselAndName(vesselId, name) ?? null;
    }
    return LogVariables.logVariableByNameAndVesselId(vesselId, name) ?? null;
  }

  removeExpressionItem(expressionItemIndex: number, expressionIndex: number): void {
    // Defensive: ensure the vessel and expressions exist
    const item = this.localExpressionItemsList[expressionItemIndex];
    if (!item || !Array.isArray(item.expressions)) return;

    // Remove the expression at the given index
    item.expressions.splice(expressionIndex, 1);

    this.$emit("onExpressionItemChanged", JSON.parse(JSON.stringify(this.localExpressionItemsList)));
  }
}
